const Search = () => {
  return (
    <section className="content max-w-xl mx-auto overflow-hidden md:max-w-2xl xl:max-w-6xl"></section>
  );
};

export default Search;
